import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Output,
  ViewChild
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import {
  MatDatepicker,
  MatDatepickerModule
} from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { OrderService } from 'src/app/core/services/order.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';

export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}
@Component({
  standalone: true,
  selector: 'app-modal-request-appraisal',
  templateUrl: './modal-request-appraisal.component.html',
  styleUrls: ['./modal-request-appraisal.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule
  ],
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter }]
})
export class ModalRequestAppraisalComponent {
  minDate: string;
  form: FormGroup;
  @ViewChild('picker') picker!: MatDatepicker<any>;
  @Output() confirmAppraisalEmitter = new EventEmitter<string>();

  constructor(
    public dialogRef: MatDialogRef<ModalRequestAppraisalComponent>,
    private orderService: OrderService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
    this.form = new FormGroup({
      expectedDate: new FormControl('', Validators.required),
      appraisalExpectedKm: new FormControl('', Validators.required)
    });
  }

  close() {
    this.picker['_destroyOverlay']();
  }

  formatDateWithoutTimezone(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Meses de 0-11, por eso sumamos 1
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  submitRequest() {
    const date = this.form.value.expectedDate;
    const formattedDate = this.formatDateWithoutTimezone(new Date(date));

    const body = {
      requestNumber: this.data,
      expectedDate: formattedDate,
      expectedKms: this.form.value.appraisalExpectedKm
    };
    this.orderService.sendRequestAppraisal(body).subscribe({
      next: () => {
        this.dialog.open(FeedbackModalComponent, {
          width: '700px',
          data: {
            text: i18next.t('appraisalRequested'),
            close: true,
            theme: 'dark'
          }
        });
        this.dialogRef.close();
        this.confirmAppraisalEmitter.emit(this.data);
      },
      error: () => {
        this.dialog.open(FeedbackModalComponent, {
          width: '400px',
          data: {
            text: i18next.t('appraisalRequestedError'),
            close: true,
            theme: 'dark'
          }
        });
      },
      complete: () => {
        console.log('Fetch complete');
      }
    });
  }
}
